export default __webpack_public_path__ + "static/media/vid.db4eaf3f.svg";